import React from 'react';
import './Legal.css';

export default function Privacy() {
  return (
    <div className="page legal-page">
      <div className="legal-hero">
        <div className="container animate-fade-up">
          <span className="eyebrow">Legal</span>
          <h1 className="display-title" style={{ fontSize: '2.4rem' }}>Privacy Policy</h1>
          <p className="legal-hero__sub">Last updated: January 1, 2026</p>
        </div>
      </div>
      <div className="section">
        <div className="container legal-content animate-fade-up">

          <section>
            <h2>1. Overview</h2>
            <p>
              PERM Systems ("we", "us", "our") operates Discord bots and a website at{' '}
              <a href="https://www.permsystems.com">www.permsystems.com</a>.
              This policy explains what data we collect, how we use it, and your rights regarding that data.
              By using PERM Systems or any of its bots, you also agree to the{' '}
              <a href="https://discord.com/privacy" target="_blank" rel="noopener noreferrer">Discord Privacy Policy</a>{' '}
              and the{' '}
              <a href="https://discord.com/terms" target="_blank" rel="noopener noreferrer">Discord Terms of Service</a>.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>PERM Systems collects only the minimum data required to provide our Services:</p>
            <ul>
              <li>
                <strong>Discord User IDs and Server IDs</strong> — required by the{' '}
                <a href="https://discord.com/developers/docs/intro" target="_blank" rel="noopener noreferrer">Discord API</a>{' '}
                to identify servers and users for bot functionality.
              </li>
              <li><strong>Command inputs</strong> — text submitted with slash commands, processed by our AI model to generate responses. Inputs are not stored long-term after processing.</li>
              <li><strong>Server configuration data</strong> — per-server settings you configure for each bot.</li>
              <li><strong>Contact form submissions</strong> — name, email address, and message content when you contact us via our website.</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use collected data solely to:</p>
            <ul>
              <li>Provide and improve our bot Services on <a href="https://discord.com" target="_blank" rel="noopener noreferrer">Discord</a>.</li>
              <li>Respond to support requests and contact form messages.</li>
              <li>Debug technical issues and monitor service health.</li>
              <li>Send important service announcements (not marketing).</li>
            </ul>
          </section>

          <section>
            <h2>4. AI Processing</h2>
            <p>
              Code Assist uses a proprietary AI model owned and operated by PERM Systems —
              not a third-party service such as{' '}
              <a href="https://openai.com" target="_blank" rel="noopener noreferrer">OpenAI</a>{' '}
              or similar providers. Code and command inputs are processed in real time and
              are not retained in our systems after a response is generated.
            </p>
          </section>

          <section>
            <h2>5. Data Sharing</h2>
            <p>
              We do not sell, rent, or trade your personal data. Data may be shared
              only with infrastructure providers operating under strict data processing
              agreements, or when required by applicable law or valid legal process.
            </p>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              Server configuration data is deleted when our bot is removed from your server.
              Command inputs processed by our AI are not stored beyond the active session.
              Contact form data is retained only as long as necessary to respond.
            </p>
          </section>

          <section>
            <h2>7. Cookies</h2>
            <p>
              Our website uses minimal, strictly necessary cookies for core functionality.
              We do not use tracking cookies, advertising cookies, or third-party analytics platforms
              such as <a href="https://analytics.google.com" target="_blank" rel="noopener noreferrer">Google Analytics</a>.
            </p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              Our Services are not directed at individuals under the age of 13. We do not
              knowingly collect data from children under 13. If you believe we have done so
              inadvertently, contact us immediately.{' '}
              <a href="https://discord.com/safety" target="_blank" rel="noopener noreferrer">Discord's safety policies</a>{' '}
              also apply to all use of our bots.
            </p>
          </section>

          <section>
            <h2>9. Your Rights</h2>
            <p>
              Depending on your jurisdiction, you may have rights to access, correct, or request
              deletion of your personal data under laws such as the{' '}
              <a href="https://gdpr.eu" target="_blank" rel="noopener noreferrer">GDPR</a>{' '}
              or{' '}
              <a href="https://oag.ca.gov/privacy/ccpa" target="_blank" rel="noopener noreferrer">CCPA</a>.
              To submit a data request, email{' '}
              <a href="mailto:privacy@permsystems.com">privacy@permsystems.com</a>.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. Significant changes will be
              announced via the{' '}
              <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer">PERM Systems Discord server</a>.
              Continued use of our Services after an update constitutes acceptance.
            </p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <p>
              Privacy questions:{' '}
              <a href="mailto:privacy@permsystems.com">privacy@permsystems.com</a>
              {' '}— or reach us on{' '}
              <a href="https://discord.gg/permsystems" target="_blank" rel="noopener noreferrer">Discord</a>.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}